import { ConstraintSpec } from '../constraints/constraint-spec'
import { ProcessingTimeSpec } from '../capacities/processing-time-spec'
import { SkillSetSpec } from './skill-set-spec'
import { Quantity, UuidUtil } from '@elderbyte/ngx-starter'
import { Duration } from '@js-joda/core'
import { SkillSetConf } from '../../../shopfloor/workcenters/capability/skillsets/skill-set-conf'
import { ConstraintConf } from '../../../shopfloor/workcenters/capability/constraints/constraint-conf'
import { ProcessingTimeConf } from '../../../shopfloor/workcenters/capability/capacities/processing-time-conf'

export class SkillSetMaterializer {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private _spec: SkillSetSpec
  private _description: string

  public static start(spec: SkillSetSpec): SkillSetMaterializer {
    return new SkillSetMaterializer(spec)
  }

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor(spec: SkillSetSpec) {
    this._spec = spec
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public description(description: string): SkillSetMaterializer {
    this._description = description
    return this
  }

  public materialize(): SkillSetConf {
    const skillSetConf = new SkillSetConf()
    skillSetConf.id = UuidUtil.strongUuid4()
    skillSetConf.skillSetSpecId = this._spec.id
    skillSetConf.spec = this._spec
    skillSetConf.description = this._description
    skillSetConf.conditions = this._spec.conditions.map((c) => this.materializeConstraint(c))
    skillSetConf.constraints = this._spec.constraints.map((c) => this.materializeConstraint(c))
    skillSetConf.capacities = this._spec.capacities.map((variantSet) =>
      this.materializeCapacity(variantSet)
    )

    return skillSetConf
  }

  /***************************************************************************
   *                                                                         *
   * Private Methods                                                         *
   *                                                                         *
   **************************************************************************/

  private materializeConstraint(spec: ConstraintSpec): ConstraintConf {
    const constraint = new ConstraintConf()
    constraint.spec = spec
    constraint.constraintSpecId = spec.id
    constraint.values = []

    return constraint
  }

  private materializeCapacity(spec: ProcessingTimeSpec[]): ProcessingTimeConf[] {
    return spec.map((p) => this.materializeProcessingTime(p))
  }

  private materializeProcessingTime(spec: ProcessingTimeSpec): ProcessingTimeConf {
    return <ProcessingTimeConf>{
      specId: spec.id,
      spec: spec,
      unitQuantity: Quantity.zero(spec.unit),
      duration: Duration.ZERO,
    }
  }
}
